module.exports = __webpack_public_path__ + "static/media/bg-card.3f0833df.svg";